import { fas } from '@awesome.me/kit-b4fd369ea4/icons';


const bmsScSideNav = {
  id: 'sc',
  children: [
      {
      id: 'scMcoMenu',
      displayName: 'Managed Care',
      role: 'SC_MCO_INV_VIEW',
      icon: fas.faClinicMedical,
      precedence: 14,
      children: [
        { id: 'scUsAmpDashboard', displayName: 'US AMP Dashboard', role: 'SC_MCO_INV_VIEW', icon: fas.faChartLine, route: '/sc/dashboard/us-amp', precedence: 30 },
      ]
    }
  ]
}

export default bmsScSideNav;